module.exports = require("@wildboar/x500/src/lib/modules/DistributedOperations/AccessPointInformation.ta");